import Button from "../Shared/Button";
import Input from "../Shared/Input";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ButtonTypes } from "../../utils/consts";
import { forgetpassword } from "../../api/Auth/forgetpassword";

const validationSchema = Yup.object({
    email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
});

const ForgetPasswordForm = () => {
    const navigate = useNavigate();
    const { mutate, error } = useMutation({
        mutationFn: forgetpassword,
        onSuccess: () => {
            const email = encodeURIComponent(formik.values.email);
            navigate(`/verify-password/${email}`);
        },
        onError: () => {
            formik.setSubmitting(false);
        },
    });
    const formik = useFormik({
        initialValues: {
            email: "",
        },
        validationSchema,
        onSubmit: (values) => {
            const formattedValues = {
                ...values,
                email: values.email.toLowerCase(),
              };
              mutate(formattedValues);
                },
    });

    return (
        <div className="flex flex-col h-full justify-center text-burntBlack">
            <div className="mb-8 md:text-start text-center">
                <h1 className="font-semibold sm:mb-2 mb-1 sm:text-[42px] text-28px">Forgot password?</h1>
                <p className="font-medium sm:text-xl max-w-[406px] md:mx-0 mx-auto">
                    Please enter your email address and check messages
                </p>
            </div>
            <form
                onSubmit={formik.handleSubmit}
                className="flex flex-col gap-5"
                action=""
            >
                <Input
                    inputStyles="md:h-16 !h-[52px]"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                        formik.touched.email && formik.errors.email
                            ? formik.errors.email
                            : ""
                    }
                    title="Email Address"
                    placeholder="someone@example.com"
                    name="email"
                    type="text"
                />
                <Button type={ButtonTypes.SUBMIT}
                    disabled={formik.isSubmitting}
                    variant="primary" className="w-full md:mt-3 mt-2 md:h-16 h-[54px]">
                    Submit
                </Button>
                {error instanceof AxiosError && (
                    <span className="text-red-500 font-bold text-lg">
                        {error?.response?.data?.message || "An error occurred"}
                    </span>
                )}

            </form>
        </div>
    );
};

export default ForgetPasswordForm;
